import { HowToMeasure1 } from '../how-to-measure-1';
import { HowToMeasure2 } from '../how-to-measure-2';
import { WomenBibsCoveralls } from './bibs-and-coveralls';
import { WomenBoots } from './boots';
import { WomenWader } from './neoprene-waders';

export const Women = () => {
  return (
    <div className='mx-auto w-full max-w-[1400px]  px-[16px] lg_px-0'>
      <WomenBoots />
      <WomenWader />
      <WomenBibsCoveralls />

      <HowToMeasure1 />
      <HowToMeasure2 image='/contact-us/women-measure.png' />
    </div>
  );
};
